// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import rtlCache from './rtl-cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

document.title = 'רק בריאות'; 

const rtlTheme = createTheme({
  direction: 'rtl',
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <CacheProvider value={rtlCache}>
    <ThemeProvider theme={rtlTheme}>
      <CssBaseline />
      <div dir="rtl">
          <App />
      </div>
    </ThemeProvider>
  </CacheProvider>
);
